import { Breadcrumb, Col, Row, DatePicker, Select } from "antd";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";

import Title from "../UI/Title/Title";
import { PaymentList } from "./paymentList";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { getPayments } from "../../api/payments";
import { getSupplierDropdown } from "../../api/supplier";
import { Pagination } from "./types";

function SupplierPayment() {
  const { RangePicker } = DatePicker;
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  const [, setSearchText] = useState("");
  const [tableKey, setTableKey] = useState(1000);
  const [payments, setPayments] = useState<any>([]);
  const [paymentById, setPaymentById] = useState<any>();

  const [selectedsupplier, setSelectedsupplier] = useState(null);
  const [formatedsupplier, setFormatedsupplier] = useState<{}[]>();

  // date
  const [from, setFrom] = useState<string>("");
  const [to, setTo] = useState<string>("");

  const [pagination, setPagination] = useState<Pagination>({
    current: 1,
    pageSize: 10,
    total: 0,
    limit: 10,
  });

  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearchText("");
    setFrom("");
    setTo("");
  };

  const {
    mutateAsync: getSupplierPaymentsMutation,
    isLoading: isPaymentsLoading,
  } = useMutation("supplierPayments", () => getPayments("", from, to), {
    onSuccess: ({ data }) => {
      setPayments(data?.data);
    },
  });

  const { isLoading: loadingsupplier } = useQuery(
    "getSupplierDropdown",
    getSupplierDropdown,
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedsupplier(
          res.data.map((supplier: any) => {
            return { value: supplier.id, label: supplier.name };
          })
        );
      },
    }
  );

  useEffect(() => {
    getSupplierPaymentsMutation();
  }, [])

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <Link to="">{t("purchases")}</Link>,
              },
              {
                title: (
                  <span className="breadcrumbcolor"> {t("payments-list")}</span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("payments-list")}`} />
        </Col>
        <Col offset={1} span={5}>
          <RangePicker
            key={tableKey}
            size="large"
            style={{ width: "100%" }}
            format={"MM/DD/YYYY"}
            placeholder={[t('start-date'), t('end-date')]}
            onChange={(dates, datesString) => {
              setFrom(datesString[0]);
              setTo(datesString[1]);
            }}
          />
        </Col>{" "}
        <Col span={5}>
          <Select
            key={tableKey}
            size="large"
            style={{ width: "100%" }}
            placeholder={`${t("select-supplier")}`}
            options={formatedsupplier}
            loading={loadingsupplier}
            value={selectedsupplier}
            onChange={(value) => {
              setSelectedsupplier(value);
            }}
          />
        </Col>
        <Col
          offset={10}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => navigate(`/supplierpayment/create`)} />
        </Col>
        <Col offset={1} span={22}>
          <PaymentList
            payments={payments}
            setPaymentById={setPaymentById}
            isPaymentsLoading={isPaymentsLoading}
            getSupplierPaymentsMutation={getSupplierPaymentsMutation}
            selectedsupplier={selectedsupplier}
          />
        </Col>
      </Row>
    </>
  );
}

export default SupplierPayment;
